<template>
  <div class="py-2">
    <h3 class="ui dividing header fdinpro default-header-green is-uppercase">
      Participa en el Bundle
    </h3>
    <div class="ui equal width grid pbundle pbundle">
      <div class="column">
        <p class="cgray">Battlefield 2042</p>
      </div>
      <div class="column">
        <div
          @click="show_request_modal = true"
          class="ui button modal-button-green"
        >
          PARTICIPAR
        </div>
      </div>
    </div>
    <bundle-request-modal
      :show="show_request_modal"
      @close="show_request_modal = false"
      ref="request_modal"
    />
  </div>
</template>

<script>
import BundleRequestModal from "./BundleRequestModal.vue";
export default {
  name: "NvidiaTicketStoreBundleRequest",
  components: { BundleRequestModal },
  data() {
    return {
      show_request_modal: false,
      stores: [],
    };
  },
  methods: {
    setStores(stores) {
      let vm = this;
      vm.stores = stores;
      vm.$refs.request_modal.setStores(stores);
    },
  },
};
</script>

<style scoped>
@import url("https://nworkforce.com/librerias/css/fonts/fonts.css");

.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}

/*  SIDE BAR BUTTONS    */
.pbundle {
  align-items: center !important;
}
.pbundle div button {
  border-radius: 2rem !important;
}
.pbundle div .cgray {
  font-weight: 700 !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
</style>
